<div class="sheet-menu" [hidden]="!handleHarmonyChords()">
  <mat-form-field appearance="fill">
    <mat-label>{{ 'sheet.menu.form.set.chord.label' | translate }}</mat-label>
    <mat-select disableRipple name="chord"
      matTooltip="{{ 'sheet.menu.form.set.chord.tip' | translate }}"
      (selectionChange)="recreateWithHarmonyChord($event)">
      <mat-option *ngFor="let harmonyChord of harmonyChords" value="{{ harmonyChord }}">
        {{ renderChordNameInSyllabic(harmonyChord) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <p>
    <mat-slide-toggle name="recreateChord" [(ngModel)]="recreateChord"
    matTooltip="{{ 'sheet.menu.chord.recreate.tip' | translate }}">
    {{ 'sheet.menu.chord.recreate.label' | translate }}</mat-slide-toggle>
  </p>
</div>

<div class="sheet-menu" [hidden]="!handleMelodyNotes()">
  <mat-form-field appearance="fill">
    <mat-label>{{ 'sheet.menu.form.set.note.label' | translate }}</mat-label>
    <mat-select disableRipple name="note"
      matTooltip="{{ 'sheet.menu.form.set.note.tip' | translate }}"
      (selectionChange)="recreateWithMelodyNote($event)">
      <mat-option *ngFor="let chromaOctave of melodyNotes" value="{{ chromaOctave }}">
        {{ renderNoteNameInSyllabic(chromaOctave) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <p>
    <mat-slide-toggle name="recreateNote" [(ngModel)]="recreateNote"
    matTooltip="{{ 'sheet.menu.note.recreate.tip' | translate }}">
    {{ 'sheet.menu.note.recreate.label' | translate }}</mat-slide-toggle>
  </p>
</div>

<div class="sheet-menu" [hidden]="!handleTonalities()">
  <mat-form-field appearance="fill">
    <mat-label>{{ 'sheet.menu.form.set.tonality.label' | translate }}</mat-label>
    <mat-select disableRipple name="tonality"
      matTooltip="{{ 'sheet.menu.form.set.tonality.tip' | translate }}">
      <mat-option *ngFor="let tonality of tonalities" value="{{ tonality }}"
        (onSelectionChange)="recreateOnTonality($event, tonality)">
        {{ renderTonalityName(tonality) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="sheet-menu" [hidden]="!handleAddMeasure()">
  <button mat-flat-button (click)="addMeasure($event)" matTooltip="{{ 'sheet.menu.form.set.add-measure.tip' | translate }}">{{ 'sheet.menu.form.set.add-measure.label' | translate }}</button>
</div>
